export default function CTASection() {
  return (
    <section className="relative w-full h-[400px] md:h-[500px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20angle%20shot%20of%20a%20modern%20minimalist%20living%20room%20with%20shopping%20bags%20from%20various%20boutiques%20placed%20on%20a%20light%20oak%20coffee%20table%2C%20afternoon%20sunlight%20pouring%20through%20sheer%20curtains%2C%20aspirational%20lifestyle%20photography%2C%20warm%20cozy%20yet%20luxurious%20atmosphere%2C%20cream%20and%20terracotta%20color%20scheme&width=1600&height=600&seq=cta-v2&orientation=landscape"
          alt="Explore the best Superbuy Spreadsheets"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/25 to-black/15"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
              explore the best
              <br />
              spreadsheets
            </h2>
            <p className="text-sm md:text-base text-white/70 max-w-md leading-relaxed">
              Ready to start shopping? Visit our main website for the latest product categories, updated spreadsheets, and exclusive deals.
            </p>
          </div>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 bg-white text-foreground-950 text-sm font-semibold rounded-full hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            Visit Main Store
            <span className="w-6 h-6 rounded-full bg-foreground-950 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-xs"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}